import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonBuilderDataService {
  uniqueId: string;
  domainId: number;
  popupMode: boolean;
  prefilledAi: boolean;
  secondaryPagesLimit = 5;
  secondaryPagesActiveSectionsLimit = 3;
  homePageSectionsLimit = 14;
  websiteType: string;
  builderType: "wvc" | "section_based" | boolean;
  ecommerceListTypes = ["ecommerce_store", "ecommerce_category", "ecommerce_sale"];
  combinedOutline = false;

  constructor() {
  }
}
